import navDimensionsIcon from 'assets/nav_dimensions_icon.png';

interface Properties {
  width?: number;
  height?: number;
}

const DimensionsIconActive = ({ width = 16, height = 16 }: Properties) => {
  return (
    <img
      src={navDimensionsIcon}
      alt=''
      width={width}
      height={height}
      style={{ filter: 'brightness(0) invert(1)' }}
    />
  );
};

export default DimensionsIconActive;
